import { useEffect, useState } from "react";
import { getBurnQuote } from "@/api";

export function useBurnQuote(token, amount) {
  const [state, setState] = useState({ quote: null, err: "", loading: false });
  useEffect(() => {
    const n = Number(amount);
    if (!token || !n || n <= 0) { setState({ quote: null, err: "", loading: false }); return undefined; }
    setState((s) => ({ ...s, loading: true, err: "" }));
    const id = setTimeout(() => {
      getBurnQuote(token, n)
        .then((quote) => setState({ quote, err: "", loading: false }))
        .catch((e) => setState({ quote: null, err: e?.response?.data?.detail || "Price unavailable", loading: false }));
    }, 600);
    return () => clearTimeout(id);
  }, [token, amount]);
  return state;
}
